module.exports = __webpack_public_path__ + "static/media/linkedin-light.e90cd93f.svg";